/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */

import { css, StyleSheet } from 'aphrodite';
import { BrandColors, Text, Typography } from '@blend/enterprise-components';
import React from 'react';
import { NotaryAPI } from '../../../api/notary/types';

const styles = StyleSheet.create({
  wrapper: {
    ...Typography.Roboto,
    padding: 8,
    fontWeight: Typography.BOOK,
  },
});

export namespace NotarySearchResult {
  export interface Props {
    result: NotaryAPI.UserResponse;
  }
}
export const NotarySearchResult: React.FC<NotarySearchResult.Props> = ({
  result: { principalId, firstName, lastName, email },
}) => (
  <div data-it={`search-result-${principalId}`} className={css(styles.wrapper)}>
    <Text color={BrandColors.NEUTRAL_700} data-it="search-result-name" displayBlock={true} fontSize="sm">
      {firstName} {lastName}
    </Text>
    <Text color={BrandColors.NEUTRAL_900} data-it="search-result-email" fontSize="md">
      {email}
    </Text>
  </div>
);
